import dayjs from "dayjs";
import style from "@/components/schedule/schedule.scss";
import {todayInfo} from "@/util/date";

export const Date = ({date, holiday = false}) => {
  const dayInfo = todayInfo({date})
  const colorStyle = ((date) => {
    if (holiday || dayInfo.isHoliday || dayInfo.isSunday) {
      return style.holiday
    } else if (dayInfo.isSaturday) {
      return style.saturday
    }
    return ''
  }) (date)

  return (<>
    <span>
      <span className={colorStyle}>{dayjs(date).format('YYYY年MM月DD日(ddd)')}</span>
      { dayInfo.isHoliday && <span className={style.holiday}> {dayInfo.holidayName}</span> }
      { dayInfo.isSekki && <span className={style.sekki}> {dayInfo.sekkiName}</span> }
    </span>
  </>)
}
